import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import AddIcon from '@material-ui/icons/Add';
import TaskResponseDialog from "./TaskResponseDialog";
import TaskDialog from "./TaskDialog";
import Typography from '@material-ui/core/Typography';
import GetAppIcon from '@material-ui/icons/GetApp';
import IconButton from '@material-ui/core/IconButton';
import Card from '@material-ui/core/Card';
import TextField from '@material-ui/core/TextField';
import MenuItem from '@material-ui/core/MenuItem';

import moment from 'moment'

import config from "../../config/config";
import setting from "../../config/setting";
import axios from 'axios';


const styles = theme => ({
    // root: {
    //     width: '100%',
    //     marginTop: theme.spacing.unit * 3,
    //     overflowX: 'auto',
    // },
    // table: {
    //     minWidth: 700,
    // },
    textField: {
        marginLeft: theme.spacing.unit,
        marginRight: theme.spacing.unit,
    },
});

const noWrap = {
    whiteSpace: "no-wrap",
    minWidth: 180,
    // background: 'linear-gradient(45deg, #FE6B8B 30%, #FF8E53 90%)',
}

let id = 0;
function createData(title, description, assignedTo, statusT, remarks, link, timestamp) {
    id += 1;
    let status = { statusT, remarks, link }
    return { title, description, assignedTo, status, timestamp };
}
function createDataNormal(title, description, from, timeStamp, status, action) {
    return { title, description, from, timeStamp, status ,action }
}
const rows = [
    createData('Collect Document', 'Please collect document A', 'Yongyi', 'Completed', "Please see attached latest doc for your perusal", "https://docs.google.com/document/export?format=docx&id=1M5oI4NLqiBd00C8yrwV9ecrEirh2CjPrN2bZhk4B5EM&token=AC4w5Vgc1Q0RkXu4UhG8sUzNFhP1CPVENw%3A1537411069092&ouid=116888327737613575152&includes_info_params=true", '14-SEP-18 16:00:02'),
    createData('Gather Figure', 'Please collect exact order amount', 'Yuri', 'Pending', null, null, '14-SEP-18 12:05:02'),
    createData('Gather Figure', 'Please collect number of fatalities', 'JiaJie', 'Completed', "Number of fatalities is 9956. Cras mattis consectetur purus sit amet fermentum. Cras justo odio, dapibus ac facilisis in, egestas eget quam. Morbi leo risus, porta ac consectetur ac, vestibulum    at eros. Praesent commodo cursus magna, vel scelerisque nisl consectetur et. Vivamus sagittis lacus vel augue laoreet rutrum faucibus dolor auctor. Aenean lacinia bibendum nulla sed consectetur. Praesent commodo cursus magna, vel scelerisque nisl consectetur et. Donec sed odio dui. Donec ullamcorper nulla non metus auctor fringilla. Cras    mattis consectetur purus sit amet fermentum. Cras justo odio, dapibus ac facilisis in,    egestas eget quam. Morbi leo risus, porta ac consectetur ac, vestibulum at eros.    Praesent commodo cursus magna, vel scelerisque nisl consectetur et. Vivamus sagittis   lacus vel augue laoreet rutrum faucibus dolor auctor. Aenean lacinia bibendum nulla    sed consectetur. Praesent commodo cursus magna, vel scelerisque nisl consectetur et.    Donec sed odio dui. Donec ullamcorper nulla non metus auctor fringilla. Cras mattis    consectetur purus sit amet fermentum. Cras justo odio, dapibus ac facilisis in,    egestas eget quam. Morbi leo risus, porta ac consectetur ac, vestibulum at eros.    Praeent commodo cursus magna, vel scelerisque nisl consectetur et. Vivamus sagittis    lacus vel augue laoreet rutrum faucibus dolor auctor. Aenean lacinia bibendum nulla    sed consectetur. Praesent commodo cursus magna, vel scelerisque nisl consectetur et.    Donec sed odio dui. Donec ullamcorper nulla non metus auctor fringilla. Cras mattis    consectetur purus sit amet fermentum. Cras justo odio, dapibus ac facilisis in,    egestas eget quam. Morbi leo risus, porta ac consectetur ac, vestibulum at eros.    Praesent commodo cursus magna, vel scelerisque nisl consectetur et. Vivamus sagittis    lacus vel augue laoreet rutrum faucibus dolor auctor. Aenean lacinia bibendum nulla    sed consectetur. Praesent commodo cursus magna, vel scelerisque nisl consectetur et.    Donec sed odio dui. Donec ullamcorper nulla non metus auctor fringilla. Cras mattis    consectetur purus sit amet fermentum. Cras justo odio, dapibus ac facilisis in,    egestas eget quam. Morbi leo risus, porta ac consectetur ac, vestibulum at eros.    Praesent commodo cursus magna, vel scelerisque nisl consectetur et. Vivamus sagittis    lacus vel augue laoreet rutrum faucibus dolor auctor. Aenean lacinia bibendum nulla    se consectetur. Praesent commodo cursus magna, vel scelerisque nisl consectetur et.    Donec sed odio dui. Donec ullamcorper nulla non metus auctor fringilla. Cras mattis    consectetur purus sit amet fermentum. Cras justo odio, dapibus ac facilisis in, Donec sed odio dui. Donec ullamcorper nulla non metus auctor fringilla.", null, '14-SEP-18 11:20:02'),
    createData('Collect Document', 'Please collect document B', 'Eric', 'Pending', null, null, '13-SEP-18 18:00:02')
];
const normalRows = [
    createDataNormal('Collect Document', 'Please collect document C', "Eric", '13-SEP-18 18:00', "Completed","View"),
    createDataNormal('Collect figure', 'Please collect order amount', "Eric", '13-SEP-18 19:00', "Pending","Respond"),
    createDataNormal('Collect Document', 'Please collect document E', "Yuri", '13-SEP-18 19:07', "Pending","Respond"),
]

class TaskList extends Component {
    constructor(props) {
        super(props);
        this.state = {
            view: false,
            queryID:"",
            open: false,
            scroll: 'paper',
            selectedTask: rows[0],
            dialogOpen: false,
            taskDialogOpen: false,
            taskInfoForResponse:{},
            taskdata: this.props.data.tasks,
            height:0,
            width: 0,
        };
        this.updateWindowDimensions = this.updateWindowDimensions.bind(this);
    }

    componentDidMount() {
        this.updateWindowDimensions();
        window.addEventListener('resize', this.updateWindowDimensions);
    }

    componentWillUnmount(){
        window.removeEventListener('resize', this.updateWindowDimensions);
    }
    updateWindowDimensions() {
        this.setState({ width: window.innerWidth, height: window.innerHeight });
    }

    componentDidUpdate(prevProps){
        let statusChange = false;
        if (prevProps.data.tasks) {
            prevProps.data.tasks.forEach( (task) =>{
                let newTask = this.props.data.tasks.find((o)=>o.id == task.id);
                //console.log(newTask);
                if(newTask != null){
                    if (task.status != newTask.status){
                        statusChange = true;
                    }
                }
            });
        

            if (prevProps.data.alert_ID != this.props.data.alert_ID ||
                prevProps.data.tasks.length != this.props.data.tasks.length || 
                statusChange == true){
                // console.log("props changed");
                this.setState({taskdata:this.props.data.tasks});

            }
        }
    }

    handleClickOpen = (task) => {
        // console.log("response view")
        // console.log(task);
        this.setState({ open: true, selectedTask: task });
    };

    handleClose = () => {
        this.setState({ open: false });
    };
    handleViewToggle = () => {
        this.setState({ view: this.state.view ? false : true });
    };

    handleTaskDialogOpen = () => {
        this.setState({taskDialogOpen: true});
    };

    handleTaskDialogClose = () => {
        this.setState({taskDialogOpen: false});

    };

    handleResponseDialogClose = () => {
        this.setState({dialogOpen: false, });

    };

    handleTaskSumitUpdate = () => {
        // console.log("refrash task list");
        this.props.submitUpdate();
    };


    handleFileDownload = (id,name) => {
        // axios.get().then(res=>{
        //     console.log(res);
        // }).catch(error => {console.log(error.response)})
        axios({
            url: config.attachment + "/" + id,
            method: 'GET',
            responseType: 'blob', // important
          }).then((response) => {
            // console.log(id)
            // console.log(name)
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', name);
            document.body.appendChild(link);
            link.click();
          }).catch(error => {console.log(error.response)});
    };
    renderQuestionView(t){
        // console.log("in question")
        // console.log(t)
        if (!t.question_type)
        {
            return;
        }
        switch (t.question_type.toLowerCase())
        {
            case "attachment":
            return (
                <div>
                    {t.attachments.length === 0 || !t.hasOwnProperty("attachment_id")? <Typography>no attachment</Typography> :
                        <Typography style = {{ display: "inline" }}>
                            {t.attachments.map(attachment => {
                                return (
                                    <Typography style = {{ display: "inline", marginRight:"1vw"}}>{attachment.file_name}
                                        <IconButton onClick={() => this.handleFileDownload(t.attachment_id, attachment.file_name)}>
                                            <GetAppIcon/>
                                        </IconButton>
                                    </Typography>);
                            })}
                        </Typography>
                    }
                    <br style ={{ lineHeight: 20 + "px" }}/>
                </div>
            );
            case "numbers":
            return (
            <TextField
                InputProps={{
                    readOnly: true,
                }}
                margin="dense"
                id="name"
                placeholder="your response here"
                fullWidth
                name = {"response"}
                type = "number"
                // onChange = {(e) => {this.handleResponseOnChange(e, t.id)}}
            />
            );
            case "boolean":
            return (
                <div>
                    <TextField
                        InputProps={{
                            readOnly: true,
                        }}
                        margin="dense"
                        id="name"
                        placeholder="your response here"
                        fullWidth
                        select
                        name = {"response"}
                        value = {t.response}
                        // onChange = {(e) => {this.handleResponseOnChange(e, t.id)}}
                    >
                        <MenuItem key={"True"} value={"True"}>Yes</MenuItem>
                        <MenuItem key={"False"} value={"False"}>No</MenuItem>
                        <MenuItem key={"N/A"} value={"N/A"}>N/A</MenuItem>
                    </TextField>
                    {t.response == "N/A" ?                 
                    <TextField
                        InputProps={{
                            readOnly: true,
                        }}
                        margin="dense"
                        id="name"
                        placeholder="your response here"
                        fullWidth
                        multiline
                        
                        type="text"
                        name = {"response"}
                        // onChange = {(e) => {this.handleResponseOnChange(e, t.id)}}
                    />:null}
                </div>
                );
            case "date":
            return (
                <TextField
                    InputProps={{
                        readOnly: true,
                    }}
                    margin="dense"
                    id="name"
                    placeholder="your response here"
                    fullWidth
                    type="date"
                    name = {"response"}
                />
                );
            case "text":
            return (
                <TextField
                    InputProps={{
                        readOnly: true,
                    }}
                    margin="dense"
                    id="name"
                    placeholder="your response here"
                    fullWidth
                    name = {"response"}
                    // onChange = {(e) => {this.handleResponseOnChange(e, t.id)}}
                />
                );
            default:
            return (
                <TextField
                    InputProps={{
                        readOnly: true,
                    }}
                    margin="dense"
                    id="name"
                    placeholder="your response here"
                    fullWidth
                    name = {"response"}
                    // onChange = {(e) => {this.handleResponseOnChange(e, t.id)}}
                />
                );
        }
    }

    render() {
        // console.log("in tasklist rendering")
        // console.log(this.props.data)
        const { classes } = this.props;
        const { selectedTask } = this.state;
        // console.log("below is the selectedTask");
        // console.log(selectedTask);
        let question_index = 0;
        const dialog = (<Dialog
            open={this.state.open}
            onClose={this.handleClose}
            scroll={this.state.scroll}
            aria-labelledby="scroll-dialog-title"
            maxWidth = 'sm'
            // fullWidth = {true}

        >
            <DialogTitle id="scroll-dialog-title">{selectedTask.description}</DialogTitle>
            <DialogContent style={{ width: "40vw", height: "50vh", maxWidth: "500px"}}>
                <DialogContentText>
                    {this.state.selectedTask.questions == null ? null :
                        <div>{this.state.selectedTask.questions.map(question => {
                        question_index++;
                        return (
                            <div key = {question.id}>
                                <Typography variant="subheading">{question_index+'. '+question.question_text}</Typography>
                                {this.renderQuestionView(question)}
                            </div>
                        );
                        })}</div>}
                    
                    <br style ={{ lineHeight: 20 + "px" }}/>
                    <br style ={{ lineHeight: 20 + "px" }}/>
                    {/* <Typography>
                        {"Status:\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0" + selectedTask.status}
                    </Typography>
                    <Typography>
                        {"Assign To:\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0" + selectedTask.assigned_user_name}
                    </Typography>
                    <Typography>
                        {"Created Date:\xa0\xa0" + moment(selectedTask.created_date).format(setting.date_format)}
                    </Typography>
                    <Typography>
                        {"Due Date:\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0" + moment(selectedTask.due_date).format(setting.date_format)}
                    </Typography> */}
                    <TextField
                        id="filled-uncontrolled"
                        label="Status:"
                        defaultValue={selectedTask.status}
                        InputProps={{
                            readOnly: true,
                        }}
                        className={classes.textField}
                        margin="normal"
                        variant="filled"
                    />
                    <TextField
                        id="filled-uncontrolled"
                        label="Assign To:"
                        defaultValue={selectedTask.assigned_user_name}
                        InputProps={{
                            readOnly: true,
                        }}
                        className={classes.textField}
                        margin="normal"
                        variant="filled"
                    />
                    <TextField
                        id="filled-uncontrolled"
                        label="Created Date:"
                        defaultValue={moment(selectedTask.created_date).format(setting.date_format)}
                        InputProps={{
                            readOnly: true,
                        }}
                        className={classes.textField}
                        margin="normal"
                        variant="filled"
                    />
                    <TextField
                        id="filled-uncontrolled"
                        label="Due Date:"
                        defaultValue={moment(selectedTask.due_date).format(setting.date_format)}
                        InputProps={{
                            readOnly: true,
                        }}
                        className={classes.textField}
                        margin="normal"
                        variant="filled"
                    />
                    
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                {/* <Button variant="contained" disabled={!selectedTask.status.link} href={selectedTask.status.link}>
                    Attachment
              </Button> */}
                <Button onClick={this.handleClose} color="primary">
                    Close
              </Button>
            </DialogActions>
        </Dialog>)
        const AlertOwnerTable = (
            <div>
            <span style={{ textAlign: "center" }}>
                <Button variant="contained" size="small" style={{ width: "100%" }} onClick = {() => {this.handleTaskDialogOpen();}}>
                    <AddIcon />
                    Add New...
                    </Button>
            </span>
            <Table className={classes.table}>
                <TableHead>
                    <TableRow onClick={this.handleViewToggle}>
                        <TableCell >Description</TableCell>
                        <TableCell >Assigned To</TableCell>
                        <TableCell >Status</TableCell>
                        <TableCell >Create Date</TableCell>
                        <TableCell >Due Date</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {this.state.taskdata == null? null:this.state.taskdata
                        .sort((a,b)=>(a.id > b.id) ? 1 : ((b.id > a.id)? -1 : 0))
                        .map(row => {
                        return (
                            <TableRow key={row.id}>
                                <TableCell >{row.description}</TableCell>
                                <TableCell >{row.assigned_user_name}</TableCell>
                                <TableCell ><Button style={noWrap} variant="contained" size="small" disabled={row.status != "Completed" && row.status != "Rejected" } onClick={() => {this.handleClickOpen(row)}}>{row.status}</Button></TableCell>
                                <TableCell >{moment(row.created_date).format(setting.date_format)}</TableCell>
                                <TableCell >{moment(row.due_date).format(setting.date_format)}</TableCell>
                            </TableRow>
                        );
                    })}
                </TableBody>

            </Table>
        </div>)
        const normalTable = (
            <div>
                {this.state.dialogOpen?<TaskResponseDialog 
                                            refreshTaskList={this.handleTaskSumitUpdate} 
                                            tasks={this.state.taskInfoForResponse} 
                                            close={this.handleResponseDialogClose} 
                                            open={true}/>:null}
                <Table className={classes.table} padding="dense">
                    <TableHead>
                        <TableRow onClick={this.handleViewToggle}>
                            <TableCell >Description</TableCell>
                            <TableCell >Status</TableCell>
                            <TableCell >Action</TableCell>
                            <TableCell >To</TableCell>
                            <TableCell >Create Date</TableCell>
                            <TableCell >Due Date</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {this.state.taskdata == null? null:this.state.taskdata
                            .sort((a,b)=>(a.id > b.id) ? 1 : ((b.id > a.id)? -1 : 0))
                            .map(row => {
                            let allowAction = row.status !== "Pending Response" || row.assigned_user_name===sessionStorage.getItem("username");
                            // console.log(allowAction);
                            // console.log(row);
                            // console.log(moment(row.created_date))
                            return (
                                <TableRow key={row.id}>
                                    <TableCell >{row.description}</TableCell>
                                    <TableCell style={{color: row.status=="Completed"?"rgba(67,176,42,1)":"rgba(188,32,75,1)"}}>{row.status}</TableCell>
                                    <TableCell >
                                        <Button 
                                            disabled={!allowAction}
                                            variant="contained" 
                                            size="small"  
                                            onClick={()=>{
                                                // console.log("clicked")
                                                if(row.status === "Completed" || row.status === "Rejected" || row.status === "Pending Review"){
                                                    // console.log("open view")
                                                    this.handleClickOpen(row);
                                                }else{
                                                    // console.log("open response")
                                                    this.setState({dialogOpen: true, taskInfoForResponse: row})
                                                }
                                            }}>
                                            {(row.status === "Completed" || row.status === "Rejected" || row.status === "Pending Review") ? "View" : "Respond"}
                                        </Button>
                                    </TableCell>
                                    <TableCell >{row.assigned_user_name}</TableCell>
                                    <TableCell >{moment(row.created_date).format(setting.date_format)}</TableCell>
                                    <TableCell >{moment(row.due_date).format(setting.date_format)}</TableCell>
                                </TableRow>
                            );
                        })}
                    </TableBody>

                </Table>
            </div>
        )
        const content_height = this.state.height - 139 + "px";
        return (
            <Card className={classes.card} style={{ textAlign: "left", overflow: "scroll", height:content_height }}>
                {this.state.open == false? null:dialog}
                <TaskDialog submitUpdate = {this.handleTaskSumitUpdate} id={this.props.data.alert_ID} open={this.state.taskDialogOpen} close = {this.handleTaskDialogClose} users={classes.users}/>                
                {this.props.owner ? AlertOwnerTable : normalTable}
            </Card>
        )
    }
}

TaskList.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(TaskList);